const aliases = {
  sid: ['学号', 'sid', 'studentid', '学生学号'],
  name: ['姓名', 'name', '学生姓名'],
  team: ['组号', 'team', '分组', '小组'],
  dorm: ['组名', 'dorm', '小组名称'],
  password: ['密码', 'password', '组密码']
}

const normalized = value => String(value ?? '').trim().toLowerCase().replace(/[\s_-]+/g, '')

export function parseClassroomRows(rows) {
  const headerIndex = rows.findIndex(row => row.some(cell => String(cell ?? '').trim()))
  if (headerIndex < 0) throw Error('Excel 中没有可导入的数据')
  const headers = rows[headerIndex].map(normalized)
  const column = key => headers.findIndex(value => aliases[key].some(alias => normalized(alias) === value))
  const indexes = Object.fromEntries(Object.keys(aliases).map(key => [key, column(key)]))
  const missing = [['sid', '学号'], ['name', '姓名'], ['team', '组号']].filter(([key]) => indexes[key] < 0).map(([, label]) => label)
  if (missing.length) throw Error(`Excel 缺少必填列：${missing.join('、')}`)

  const groups = new Map(), warnings = []
  for (let i = headerIndex + 1; i < rows.length; i++) {
    const row = rows[i]
    if (!row.some(cell => String(cell ?? '').trim())) continue
    const sidCell = row[indexes.sid]
    const sid = String(sidCell ?? '').trim(), name = String(row[indexes.name] ?? '').trim()
    const team = Number(row[indexes.team])
    if (!sid || !name || !Number.isInteger(team) || team <= 0) throw Error(`Excel 第 ${i + 1} 行的学号、姓名或组号无效`)
    if (typeof sidCell === 'number') warnings.push(`第 ${i + 1} 行学号是数字格式；如需保留前导零，请在 Excel 中把学号列设为文本`)
    const dorm = indexes.dorm < 0 ? '' : String(row[indexes.dorm] ?? '').trim()
    const password = indexes.password < 0 ? '' : String(row[indexes.password] ?? '').trim()
    if (!groups.has(team)) groups.set(team, {team, dorm: dorm || `${team}组`, ...(password ? {password} : {}), students: []})
    const group = groups.get(team)
    if (dorm && group.dorm !== dorm) throw Error(`Excel 第 ${i + 1} 行与同组的组名不一致`)
    if (password && group.password && group.password !== password) throw Error(`Excel 第 ${i + 1} 行与同组的密码不一致`)
    if (password && !group.password) group.password = password
    group.students.push({sid, name})
  }
  if (!groups.size) throw Error('Excel 表头下没有学生数据')
  const teams = [...groups.values()].sort((a, b) => a.team - b.team)
  return {teams, studentCount: teams.reduce((sum, team) => sum + team.students.length, 0), warnings}
}
